/**
 * Payroll run view-model — shared shapes + display helpers for the runs list
 * and the run-detail grid. Keeps the route components lean.
 */
import type { payrollRuns } from "@flint/api-contract";
import type { z } from "zod";

export type RunDetailView = z.infer<typeof payrollRuns.runDetail>;
export type RunLineView = z.infer<typeof payrollRuns.runLine>;
export type RunListRowView = z.infer<typeof payrollRuns.listRow>;
export type PayrollRunStatus = z.infer<typeof payrollRuns.payrollRunStatus>;

/** "May 2026" from a YYYY-MM-DD first-of-month string (UTC, locale-formatted). */
export function periodLabel(periodMonth: string): string {
  const d = new Date(`${periodMonth}T00:00:00.000Z`);
  return d.toLocaleDateString("en-IN", { month: "long", year: "numeric", timeZone: "UTC" });
}

/** Status pill tone + label — draft (amber) · approved (sky) · paid (green) · void (muted). */
export function statusPill(status: PayrollRunStatus): { label: string; className: string } {
  switch (status) {
    case "draft":
      return {
        label: "Draft",
        className: "bg-warn-50 text-warn border border-warn-100",
      };
    case "approved":
      return {
        label: "Approved",
        className: "bg-sky-50 text-sky-700 border border-sky-100",
      };
    case "paid":
      return {
        label: "Paid",
        className: "bg-ok-50 text-ok border border-ok",
      };
    case "void":
      return {
        label: "Void",
        className: "bg-bg text-muted border border-line",
      };
  }
}
